module.exports = __webpack_public_path__ + "static/media/lightningpayloader.8812cfed.gif";